import { render, staticRenderFns } from "./StoreConfig.vue?vue&type=template&id=64970934&scoped=true"
import script from "./StoreConfig.vue?vue&type=script&lang=js"
export * from "./StoreConfig.vue?vue&type=script&lang=js"
import style0 from "./StoreConfig.vue?vue&type=style&index=0&id=64970934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64970934",
  null
  
)

export default component.exports